import { ReactNode } from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface ClientPageLayoutProps {
  title: string;
  subtitle?: string;
  showBackButton?: boolean;
  actions?: ReactNode;
  children: ReactNode;
}

export function ClientPageLayout({ 
  title, 
  subtitle, 
  showBackButton,
  actions, 
  children 
}: ClientPageLayoutProps) {
  const navigate = useNavigate();

  return (
    <div className="max-w-6xl mx-auto space-y-6 p-6">
      {/* Header simple y claro */}
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-4">
          {showBackButton && (
            <Button variant="ghost" size="sm" onClick={() => navigate(-1)}>
              <ArrowLeft className="w-4 h-4" />
            </Button>
          )}
          <div>
            <h1 className="text-2xl font-bold">{title}</h1>
            {subtitle && (
              <p className="text-muted-foreground text-sm mt-1">{subtitle}</p>
            )}
          </div>
        </div>
        {actions && <div className="flex gap-2">{actions}</div>}
      </div>
      
      {/* Contenido con espaciado generoso */}
      <div className="space-y-6">{children}</div>
    </div>
  );
}